import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
  const { wishlist } = useApp();
  if (wishlist.length === 0) {
    return (
      <div className="max-w-6xl mx-auto px-6 py-32 text-center" data-testid="empty-wishlist">
        <h1 className="text-5xl font-serif tracking-tight">Your wishlist is empty</h1>
        <p className="mt-4 opacity-70">Save your favorites for later.</p>
        <Link to="/shop"><Button className="rounded-none mt-8 px-10 h-12 label-xs">Explore Products</Button></Link>
      </div>
    );
  }
  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16" data-testid="wishlist-page">
      <h1 className="text-5xl font-serif tracking-tighter mb-12">Wishlist<span className="opacity-40 text-2xl align-top ml-3">({wishlist.length})</span></h1>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 lg:gap-8">
        {wishlist.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
      </div>
    </div>
  );
}
